import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const storage = getStorage();

export const uploadImage = async (mediaArray, equipmentId = "") => {
  const uploadPromises = mediaArray.map(async (media) => {
    try {
      const response = await fetch(media);
      const blob = await response.blob();

      const mediaRef = ref(
        storage,
        `window-cleaning/defects${new Date().getTime()}_` + equipmentId
      );

      const snapshot = await uploadBytes(mediaRef, blob);
      const mediaUrl = await getDownloadURL(snapshot.ref);
      return mediaUrl;
    } catch (error) {
      console.log(error);
      return null;
    }
  });

  const mediaUrls = await Promise.all(uploadPromises);
  return mediaUrls.filter((url) => url !== null);
};

export const uploadSingleImage = async (media) => {
  try {
    if (typeof media !== "string" || !media.trim()) {
      return null;
    }

    const response = await fetch(media);
    const blob = await response.blob();

    const timestamp = Date.now();
    const randomSuffix = Math.random().toString(36).slice(2, 8);

    const mediaRef = ref(
      storage,
      `buildings/${timestamp}_${randomSuffix}`
    );

    const snapshot = await uploadBytes(mediaRef, blob);
    const mediaUrl = await getDownloadURL(snapshot.ref);
    return mediaUrl;
  } catch (error) {
    console.log(error);
    return null;
  }
};